import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectSelectedGeneralReport = createSelector(
  [selectGeneralReportsState],
  ({ selectedReport }) => selectedReport
)
